<script>
    export default {
        methods: {
            filterUmbrellaModel(event) {
                const itemId = event.target.dataset.id;

                if (event.target.className === 'active') {
                    const index = this.$parent.selectedUmbrellaModels.indexOf(itemId);
                    if (index > -1) {
                        this.$parent.selectedUmbrellaModels.splice(index, 1);
                    }

                    event.target.classList.remove('active');
                } else {
                    this.$parent.selectedUmbrellaModels.push(itemId);
                    event.target.classList.add('active');
                }
                this.$parent.listSelectedUmbrellas();
                this.$parent.listByUmbrellaModels();
            },

            clearUmbrellaSelection() {
                this.$parent.selectedUmbrellaModels = [];
                document.querySelectorAll('.umbrella-selection ul li.active').forEach(function (item) {
                    item.classList.remove('active');
                });
                this.$parent.listSelectedUmbrellas();
                this.$parent.listByUmbrellaModels();
                this.$parent.showIcons();
            }
        },
    }
</script>

<template>
    <div class="umbrella-selection">
        <ul>
            <li v-for="model in $parent.models"
                @click="filterUmbrellaModel"
                :data-id="model.key"
                :class="{ 'active': $parent.selectedUmbrellaModels && $parent.selectedUmbrellaModels.includes(model.key) }"
            >
                {{ model.title }}
            </li>
        </ul>

        <button v-show="$parent.selectedUmbrellaModels.length > 0"
                @click="clearUmbrellaSelection"
                v-text="this.$parent.t('dealer.reset')"
        >

        </button>
    </div>
</template>